<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="60%">
      <div class="card-head-no">（最多可同时选五个设备）</div>
      <div class="dialog-content">
        <div class="leftShow">
          <div>进线</div>
          <div v-for="(item, index) in checked" :key="'new'+index" class="device">
            <el-checkbox v-model="item.checked" @change="change">{{
              item.name
            }}</el-checkbox>
          </div>
          <div>出线</div>
          <div v-for="(item, index) in checkeds" :key="index" class="device">
            <el-checkbox v-model="item.checked" @change="change">{{
              item.name
            }}</el-checkbox>
          </div>
        </div>
        <div class="detail-ban">
          <div
            id="myEcharts"
            ref="myEcharts"
            :style="{ height: 400 + 'px' }"
          ></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
var myChart;
export default {
  name: "losschart",
  data() {
    return {
      title: "",
      dialogVisible: false,
      checked: [],
      checkeds: [],
      option: {
        title: {
          text: "【" + "1A 2号变压器" + "】损耗曲线",
          bottom: "0%",
          left: "center",
        },
        color: ["#2DB9E3", "#FF877B",'#627ccb','#94ce79','#fac858','#f75881'],
        tooltip: {
          trigger: "axis",
          show: true,
          confine: true,
        },
        legend: {
          show: false,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          data: [],
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "用电量(kwh)",
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#f5f5f5"],
              width: 1,
              type: "solid",
            },
          },
        },
        series: [],
      },
    };
  },
  mounted() {
    for (let i = 0; i < 3; i++) {
      this.checkeds.push({
        name: "1A-4011:#1T低压进线开关" + i,
        data: [
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
        ],
      });
      this.checked.push({
        name: "1A#1变压器 " + i,
        data: [
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
          Math.floor(Math.random() * 350 + 1),
        ],
      });
    }
    // this.initn();
  },
  methods: {
    //组件调用方法
    initn() {
      let item = "";
      let title = "";
      let date = new Date();
      let month = parseInt(date.getMonth() + 1);
      let day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      item = date.getFullYear() + "-" + month + "-" + day;
      date.setDate(day + 1);
      title =
        "(" +
        date.getFullYear() +
        "-" +
        month +
        "-" +
        day +
        " 00:00" +
        "~" +
        month +
        "-" +
        date.getDate() +
        " 00:00 )";
      let data = [];
      for (let i = 0; i < 24; i++) {
        if (i < 10) {
          data.push(item + " " + 0 + i + ":00");
        } else {
          data.push(item + " " + i + ":00");
        }
      }
      this.title = "【" + "1A 2号变压器" + "】设备用电曲线";
      this.option.title.text = "【" + "1A 2号变压器" + "】设备用电曲线" + title;
      this.option.xAxis.data = data;
      this.dialogVisible = true;
      setTimeout((v) => {
        myChart = echarts.init(document.getElementById("myEcharts"));
        myChart.setOption(this.option);
        myChart.resize();
        $(window).resize(function () {
          myChart.resize();
        });
      }, 500);
    },
    change(val) {
      let data = [];
      let  legendSelects = {}
       this.checked.map((v) => {
        if (v.checked) {
        legendSelects[v.name] = true
          data.push({
            name: v.name,
            type: "line",
            data: v.data,
            smooth: true,
            showSymbol: false,
          });
        } else {
            legendSelects[v.name] = false
        }
      });
      this.checkeds.map((v) => {
        if (v.checked) {
        legendSelects[v.name] = true
          data.push({
            name: v.name,
            type: "line",
            data: v.data,
            smooth: true,
            showSymbol: false,
          });
        } else {
            legendSelects[v.name] = false
        }
      });
      this.option.legend.selected = legendSelects
      this.option.series = data;
      myChart.setOption(this.option);
    },
  },
};
</script>

<style scoped>
.card-head-no {
  color: #909399;
}
.card-head-no .device {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 5px;
  font-size: 14px;
}
.dialog-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.dialog-content .leftShow {
  min-height: 400px;
  line-height: 40px;
  border-right: 1px solid #ebeef5;
}
.dialog-content .leftShow div {
  padding-right: 12px;
  border-bottom: 1px solid #ebeef5;
}
.dialog-content .leftShow .device {
  margin-left: 15px;
}
.detail-ban {
  width: 100%;
  border-radius: 4px;
  background-color: #fff;
}
</style>